import React, { useState, useEffect } from 'react';
import "./hospitals.css";
import Sidebar from '../../../Components/Sidebar/Sidebar';
import hospital1 from "../../../Assets/hospitals.jpg";
import { Link } from 'react-router';
import hospital2 from "../../../Assets/sound-barrier-india.webp";
import hospital3 from "../../../Assets/hospitals/Our Hospital Sound Barrier Solutions.png";
import hospital4 from "../../../Assets/sound-barrier-manufacturer.webp";
import hospital5 from "../../../Assets/hospitals/hospital-1.png";
import hospital6 from "../../../Assets/hospitals/hospital-2.png";
import hospital7 from "../../../Assets/hospitals/hospital-3.png";
import hospital8 from "../../../Assets/hospitals/hospital-4.png";
import hospital9 from "../../../Assets/hospitals/hospital-5.png";
import hospital10 from "../../../Assets/hospitals/hospital-6.png";
import HNavbar from '../../../Components/Navbar/HNavbar';
import MFooter from '../../../Components/Main-Footer/MFooter';

function Hospitals() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    const handleClick = () => {
        const name = document.getElementById('name').value.trim();
        const mail = document.getElementById('mail').value.trim();
        const phone = document.getElementById('phone').value.trim();
        const message = document.getElementById('message').value.trim();

        const subject = `New message from ${name}`
        const body = `Name: ${name}%0AEmail: ${mail}%0APhone: ${phone}%0A%0AMessage:%0A${message}`;
        const mailtoLink = `mailto:mail@acousticalsurfaces.in?subject=${encodeURIComponent(subject)}&body=${body}`;

        window.open(mailtoLink, '_blank');

        document.getElementById('name').value = '';
        document.getElementById('mail').value = '';
        document.getElementById('phone').value = '';
        document.getElementById('message').value = '';
    }
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    useEffect(() => {
        const animatedElements = document.querySelectorAll('.hospital-header,.hospital-header1,.hospital-header2,.hospital-header3,.hospital-header4,.hospital-header5,.hospital-header6');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                } else {
                    entry.target.classList.remove('animate');
                }
            });
        }, { threshold: 0.3 });

        animatedElements.forEach(el => observer.observe(el));

        return () => {
            animatedElements.forEach(el => observer.unobserve(el));
        };
    }, []);
    return (
        <>
        <HNavbar />
            <section id='hospitals' className='main-hospitals1'>
                <div className='container p-0'>
                    <Sidebar />
                    <div className='row main-hospitals'>
                        <div className='col-12 col-md-6 d-flex justify-content-center align-items-center p-3'>
                            <div className='image-wrapper'>
                                <img className='img-fluid hospitals-home-img' src={hospital1} alt="hospital" />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 d-flex flex-column justify-content-center align-items-start text-white'>
                            <h1 className='hospital-header'>Hospital Noise Control Solutions | Sound Barrier</h1>
                            <p className='white-para'>Hospitals require a quiet and peaceful environment for patient recovery and medical care. Excessive noise from equipment, generators, HVAC systems, and construction activities can disturb patients and healthcare staff. <b>Sound Barrier Manufacture</b> provides advanced hospital noise control solutions using high-performance sound barrier blankets and acoustic systems.</p>
                            <p className='white-para'>Our solutions are designed to reduce internal noise levels and prevent patient disturbance while maintaining hospital operations.</p>
                            <Link to="/contact"><button className='btn' type="button">Contact us</button></Link>
                        </div>
                    </div>
                </div>
            </section>

            <section id='hospitals'>
                <div className='container noice-control mt-4'>
                    <h1 className='hospital-header1'>Why Noise Control is Important in Hospitals</h1>
                    <p>Hospitals are sensitive environments where noise control is critical. High noise levels can cause:</p>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6 d-flex justify-content-center'>
                            <img className='img-fluid' src={hospital2} alt="hospital" style={{ height: "500px" }} />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column justify-content-center align-items-center'>
                            <ul className='list'>
                                <li>Patient discomfort and stress</li>
                                <li>Sleep disturbance in recovery wards</li>
                                <li>Communication issues between staff</li>
                                <li>Increased anxiety in critical care units</li>
                                <li>Regulatory non-compliance</li>
                            </ul>
                        </div>
                    </div>
                    <p>Installing professional hospital sound barriers ensures a calm and controlled atmosphere.</p>

                    <h1 className='hospital-header2' style={{ marginTop: "10px" }}>Our Hospital Sound Barrier Solutions</h1>
                    <p>Sound Barrier Manufacture supplies industrial-grade sound barrier blankets and acoustic enclosures suitable for hospital environments.</p>
                    <div className='row mt-5'>
                        <div className='col-sm-12 col-md-6'>
                            <h5>Key Features:</h5>
                            <ul className='list'>
                                <li>High STC-rated sound barrier material</li>
                                <li>Safe and non-toxic materials</li>
                                <li>Fire-retardant options available</li>
                                <li>Easy installation and removal</li>
                                <li>Suitable for indoor and temporary applications</li>
                                <li>Durable and reusable</li>
                            </ul>
                            <p>Our hospital acoustic barriers are ideal for managing equipment noise and renovation activities inside healthcare facilities.</p>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={hospital3} alt="hospital" style={{ height: "400px" }} />
                        </div>
                    </div>

                    <h1 className='hospital-header3' style={{ marginTop: "30px" }}>Benefits of Hospital Noise Control Systems</h1>
                    <p>Using hospital sound barriers helps:</p>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={hospital4} alt="hospital" />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column justify-content-center align-items-center'>
                            <ul className='list'>
                                <li>Reduce patient disturbance</li>
                                <li>Improve patient recovery conditions</li>
                                <li>Maintain a quiet healing environment</li>
                                <li>Meet healthcare acoustic standards</li>
                                <li>Improve staff productivity and communication</li>
                            </ul>
                        </div>
                    </div>
                    <h1 className='hospital-header4' style={{ marginTop: "20px" }}>Applications in Hospitals</h1>
                    <h4 className='sub-title mt-3'>Our noise control solutions are suitable for:</h4>
                    <div className='row'>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={hospital5} alt="Generator rooms" />
                            <p>Generator rooms</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={hospital6} alt="HVAC plant rooms" />
                            <p>HVAC plant rooms</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={hospital7} alt="Medical equipment enclosures" />
                            <p>Medical equipment enclosures</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={hospital8} alt="Temporary renovation areas" />
                            <p>Temporary renovation areas</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={hospital9} alt="ICU and patient ward noise control" />
                            <p>ICU and patient ward noise control</p>
                        </div>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={hospital10} alt="Maintenance work inside hospital" />
                            <p>Maintenance work inside hospital buildings</p>
                        </div>
                    </div>
                </div>
            </section>

            <section id='hospitals' className='call'>
                <div className='container'>
                    <h1 className='hospital-header5'>Why Choose Us?</h1>

                    <ul className='hospital-list white-para'>
                        <li>Experienced acoustic solution provider</li>
                        <li>High-performance hospital sound barrier systems</li>
                        <li>Custom size and design options</li>
                        <li>Safe materials suitable for healthcare use</li>
                        <li>Fast supply and professional support</li>
                        <li>Cost-effective indoor noise control solutions</li>
                    </ul>
                    <p className='white-para'>We understand the importance of maintaining silence and comfort in healthcare facilities.</p>

                    <h1 className='hospital-header6'>Contact Us for Hospital Noise Control Solutions</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <p className='white-para'>Looking for reliable hospital noise control systems?</p>
                            <p className='white-para'>Sound Barrier Manufacture provides customized sound barrier solutions designed to reduce internal noise and protect patient comfort.</p>
                            <p className='white-para'>Contact us today for expert consultation and hospital acoustic solutions.</p>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                            <div className="row">
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        className="form-control"
                                        placeholder="Name *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="email"
                                        name="mail"
                                        id="mail"
                                        className="form-control"
                                        placeholder="Email *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        className="form-control"
                                        placeholder="Phone *"
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <textarea
                                        rows={4}
                                        id="message"
                                        className="form-control"
                                        placeholder="Message *"
                                    ></textarea>
                                </div>
                                <div className="col-12">
                                    <button
                                        className="btn"
                                        type="button"
                                        onClick={handleClick}
                                    >
                                        SEND
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )
            }
            <MFooter />
        </>
    )
}

export default Hospitals